<div class="inicio">
  <p class="titulo">
    ASIGNACIÓN DE EQUIPO
    <button
      mat-mini-fab
      color="primary"
      matTooltip="Click para más información"
      (click)="clickMasInformacion($event)"
    >
      <mat-icon>info</mat-icon>
    </button>
  </p>

  <div class="columna_1">
    <mat-progress-bar
      *ngIf="flagLoadingEmpleados"
      mode="indeterminate"
    ></mat-progress-bar>
    <h4
      *ngIf="flagLoadingEmpleados"
      style="
        background-color: antiquewhite;
        text-align: center;
        border-radius: 10px;
      "
    >
      <strong>Espere un momento, cargando información...</strong>
    </h4>
    <div class="columnas_2">
      <div class="grid-container">
        <div class="celda">
          <mat-label class="negrita"
            >Nombre del empleado:
            <mat-label class="advertencia">*</mat-label></mat-label
          >
          <mat-form-field appearance="fill">
            <mat-select
              [formControl]="empleado_seleccionado"
              [disabled]="flagLoadingEmpleados"
              #singleSelect1
              (selectionChange)="clickLlenarDatosDelColaborador($event)"
            >
              <mat-option>
                <ngx-mat-select-search
                  [formControl]="input_colaborador"
                  oninput="
                    this.value ? (this.value = this.value.toUpperCase()) : null
                  "
                  placeholderLabel="Buscar empleado"
                  noEntriesFoundLabel="Empleado no encontrado"
                ></ngx-mat-select-search>
              </mat-option>
              <mat-option
                *ngFor="let option of listaFiltradaColaboradores | async"
                [value]="option"
              >
                {{ option.nomb_compl }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="celda">
        <mat-label class="negrita"
          >Tipo de equipo requerido:<mat-label class="advertencia"
            >*</mat-label
          ></mat-label
        >
        <mat-form-field appearance="fill">
          <mat-select
            placeholder="Selecciona el tipo de activo"
            [formControl]="activo"
            (selectionChange)="clickSeleccionarTipoDispositivo($event)"
          >
            <mat-option *ngFor="let activo of tablas" [value]="activo">{{
              activo
            }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="columna_1">
    <p class="subtitulo">Equipos disponibles</p>

    <mat-form-field appearance="fill">
      <input
        matInput
        (keyup)="filtroDataDource($event)"
        placeholder="Ingrese el dato a buscar"
      />
    </mat-form-field>

    <div>
      <mat-progress-bar
        mode="indeterminate"
        *ngIf="cargando"
      ></mat-progress-bar>

      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="OPCIONES">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>OPCIONES</th>
          <td mat-cell *matCellDef="let element">
            <button
              mat-mini-fab
              color="primary"
              matTooltip="Para asignar este equipo debes dar click"
              (click)="
                clickAsignar(
                  element.id,
                  element.tipo,
                  element.name,
                  element.comment
                )
              "
            >
              <mat-icon>check_circle</mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="NOMBRE">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>NOMBRE</th>
          <td mat-cell *matCellDef="let element">{{ element.name }}</td>
        </ng-container>

        <ng-container matColumnDef="NÚMERO DE SERIE">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            NÚMERO DE SERIE
          </th>
          <td mat-cell *matCellDef="let element">{{ element.serial }}</td>
        </ng-container>

        <ng-container matColumnDef="TIPO">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>TIPO</th>
          <td mat-cell *matCellDef="let element">{{ element.tipo }}</td>
        </ng-container>

        <ng-container matColumnDef="MODELO">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>MODELO</th>
          <td mat-cell *matCellDef="let element">{{ element.modelo }}</td>
        </ng-container>

        <ng-container matColumnDef="FABRICANTE">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>FABRICANTE</th>
          <td mat-cell *matCellDef="let element">
            {{ element.manufacturers_id }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="encabezadostabla"></tr>
        <tr mat-row *matRowDef="let row; columns: encabezadostabla"></tr>
      </table>

      <div class="no-result" *ngIf="!cargando && !dataSource.data.length">
        Sin resultados.
      </div>

      <mat-paginator
        class="mat-elevation-z8"
        [pageSizeOptions]="[10, 20, 30, 40, 50]"
        showFirstLastButtons
      ></mat-paginator>
    </div>
  </div>
</div>
